import omit from 'lodash/omit'
import cloneDeep from 'lodash/cloneDeep'
import {
  GIFT_FUND_ITEM_SCHEMA_VERSION,
  GIFT_FUND_SOURCE_CATALOG,
  GIFT_FUND_SOURCE_CUSTOM,
} from './giftFundHelpers'
import { createEmptyCatalogSelection } from './giftFundCatalogPool'

const serializeMaybeTimestamp = (value) => {
  if (!value) {
    return null
  }

  if (typeof value === 'string') {
    return value
  }

  if (typeof value.toDate === 'function') {
    return value.toDate().toISOString()
  }

  if (value instanceof Date) {
    return value.toISOString()
  }

  return value
}

export const mapGiftFundItemFromDoc = (doc) => {
  if (!doc) {
    return null
  }

  return {
    id: doc.id,
    schemaVersion: doc.schemaVersion ?? GIFT_FUND_ITEM_SCHEMA_VERSION,
    sourceType: doc.sourceType === GIFT_FUND_SOURCE_CATALOG ? GIFT_FUND_SOURCE_CATALOG : GIFT_FUND_SOURCE_CUSTOM,
    rewardGroupId: doc.rewardGroupId || null,
    availableFromTierId: doc.availableFromTierId || null,
    isActive: doc.isActive === true,
    isArchived: doc.isArchived === true,
    productCode: doc.productCode || '',
    title: doc.title || '',
    brandName: doc.brandName || '',
    volumeText: doc.volumeText || '',
    description: doc.description || '',
    specifications: doc.specifications && typeof doc.specifications === 'object' ? doc.specifications : {},
    photos: Array.isArray(doc.photos) ? doc.photos : [],
    quantity: Number.isInteger(doc.quantity) ? doc.quantity : 0,
    catalogProductId: doc.catalogProductId || null,
    catalogSource: doc.catalogSource || null,
    catalogTitle: doc.catalogTitle || null,
    catalogBarcode: doc.catalogBarcode || null,
    catalogBrandName: doc.catalogBrandName || null,
    catalogAvatarFileName: doc.catalogAvatarFileName || null,
    catalogPrice: doc.catalogPrice != null ? doc.catalogPrice : null,
    catalogDescriptionShort: doc.catalogDescriptionShort || null,
    catalogIsActive: typeof doc.catalogIsActive === 'boolean' ? doc.catalogIsActive : null,
    catalogIsArchived: typeof doc.catalogIsArchived === 'boolean' ? doc.catalogIsArchived : null,
    catalogQuantity: doc.catalogQuantity != null ? doc.catalogQuantity : null,
    catalogUnavailable: doc.catalogUnavailable === true,
    catalogSelection:
      doc.sourceType === GIFT_FUND_SOURCE_CATALOG && doc.catalogSelection && typeof doc.catalogSelection === 'object'
        ? doc.catalogSelection
        : doc.sourceType === GIFT_FUND_SOURCE_CATALOG
          ? createEmptyCatalogSelection()
          : null,
    createdAt: serializeMaybeTimestamp(doc.createdAt),
    updatedAt: serializeMaybeTimestamp(doc.updatedAt),
    updatedBy: doc.updatedBy || null,
  }
}

export const stripLocalPhotoFields = (photos = []) =>
  (Array.isArray(photos) ? photos : []).map((photo) =>
    omit(cloneDeep(photo), ['imageUrl', 'file', 'needUpload', 'uploadProgress'])
  )
